import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { useIsDesktop } from '@/shared/hooks/use-is-desktop';
import { Button } from '@/shared/uikit/Button';
import { Text } from '@/shared/uikit/Text';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { GlossaryModalProps } from '@/widgets/modals/types';

import { ModalContainerV1 } from '../containers/ModalContainerV1';

export const GlossaryModal: FC<GlossaryModalProps> = () => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'glossary' });
  const isDesktop = useIsDesktop();
  const closeModal = useModalsStore((s) => s.closeModal);

  return (
    <ModalContainerV1 title={t('title')}>
      <List>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
        <ListItem>
          <Bold>Test</Bold> <Text>Lorem ipsum, dolor sit amet consectetur</Text>
        </ListItem>
      </List>
      {!isDesktop && (
        <CloseButtonWrapper>
          <CloseButton onClick={closeModal} type="default">
            {t('close')}
          </CloseButton>
        </CloseButtonWrapper>
      )}
    </ModalContainerV1>
  );
};

const Bold = styled(Text)`
  font-weight: 700;
`;

const List = styled.ol`
  margin-left: 16px;
`;

const ListItem = styled.li`
  &::marker {
    font-weight: 700;
  }
`;

const CloseButtonWrapper = styled.div`
  background: ${COLORS.white};
  padding: 16px 0 24px 0;
  margin-top: auto;
`;

const CloseButton = styled(Button)`
  width: 100%;
  height: 44px !important;
`;
